<template>
	<div>
		<div class="bgCol second">
		    <div class="item files">
		        <div class="label" v-if="type==1">请拍摄植株局部照片(3张):</div>
				<div class="label" v-if="type==2">请拍摄开工前对应植株部位照片(3张):</div>
				<div class="label" v-if="type==3">请拍摄完成后对应植株部位照片(3张):</div>
		            <el-upload :action="uploadAction" list-type="picture-card" :headers="myHeaders" :limit="3"
		            	:on-exceed="handlePartExceed"
		            	:on-success="handlePartSuccess" :file-list="partFileList" :on-remove="handlePartRemove" v-if="is_edit===true">
						<div class="crop"></div>
		        </el-upload>		
					   
					 <img v-else :src="item.url"
					 	class="avatar" style="width: 200px; height: 200px; " v-for="(item,index) in partFileList"/>
		    </div>
			<div class="item" v-if="type==1">
			    
			<span>说明：1、地面施肥拍摄要求，挖开灌溉点土壤20cm，拍摄土壤横切面湿度情况。
			
			2、叶面施肥拍摄要求，拍摄植株树冠局部照。</span>
			
					 
			</div>
		</div>
		
	</div>
</template>
<script>
	
	import axios from 'axios';
		export default {
			name: "Part",
			props: {
				work_task_id: {
					type: Number,
					default: 0
				},	
				type: {
					type: Number,
					default: 1
				},	
				is_edit: {
					type: Boolean,
					default: false
				},	
				images: {
					type: Array,
					default:()=> []
				},	
			},
			data() {
				return {
					uploadAction: axios.defaults.baseURL + "/upload/image",
					myHeaders: {
						authorization: "Bear " + localStorage.getItem("token")
					},
					part_images:this.images,
                    partFileList:[],     
				}
				},
				mounted() {
					this.images.forEach((item,index)=>{
						this.partFileList.push({url:item})
					})
				},
				methods:{
					handlePartSuccess(response, file, fileList) {
						this.part_images.push(response.data)
					},
					handlePartRemove(file, fileList) {

						if (this.action == 1) {
							var url = file.response.data;
						} else {
							var url = file.url;
						}
						var index = this.part_images.indexOf(url)
						this.part_images.splice(index, 1);;
					},
					beforeUpload(file) {
						const isJPG = file.type === 'image/jpeg';
						const isPng = file.type === 'image/png';
						const isLt2M = file.size / 1024 / 1024 < 2;
						if (!isLt2M) {
							this.$message.error('上传图片大小不能超过 2MB!');
						}
						if (!isJPG && !isPng) {
					
							this.$message.error('上传图片只能是 JPG或PNG 格式!');
							return false
						} else {
							return true
						}
					},
					handlePartExceed(files, fileList) {
						this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
					},
					
				}
			}
		

</script>

<style>
</style>
